export const VALIDATE_SELLITEMS_START = 'VALIDATE_SELLITEMS_START';
export const VALIDATE_SELLITEMS_SUCCESS = 'VALIDATE_SELLITEMS_SUCCESS';
export const VALIDATE_SELLITEMS_FAILURE = 'VALIDATE_SELLITEMS_FAILURE';
